import { useContext} from 'react';
import { Header } from '../Header';
import { UserContext } from '../../../context/UserContext';

type GreetingsHeaderProps = {
    title?: string;
    subtitle: string;
};

export const GreetingsHeader = ({ title, subtitle }: GreetingsHeaderProps) => {
    const userContext = useContext(UserContext)

    if(title && userContext !== undefined) {
        title = title.replace('<me.name>', userContext.name)
    }

    return (
        <>
        { userContext !== undefined && true &&
            <Header title={title !== undefined ? title : userContext.name} subtitle={subtitle} />
        }
        </>
    )
}